var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F4F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.361 26.8753C26.6441 26.8753 29.3056 24.2138 29.3056 20.9307C29.3056 17.6475 26.6441 14.9861 23.361 14.9861C20.0779 14.9861 17.4164 17.6475 17.4164 20.9307C17.4164 24.2138 20.0779 26.8753 23.361 26.8753Z",
    fill: "#F6F5FF",
    stroke: "#525254",
    strokeWidth: 0.836364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9276 31.4478C15.8411 30.0432 17.0909 28.889 18.5637 28.09C20.0364 27.2911 21.6854 26.8726 23.3609 26.8726C25.0364 26.8726 26.6854 27.2911 28.1581 28.09C29.6308 28.889 30.8807 30.0432 31.7942 31.4478",
    stroke: "#525254",
    strokeWidth: 0.836364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.109d4357e1557d3393e4a88886bf72c6.svg";
export { ForwardRef as ReactComponent };